<template lang="html">
    <!-- Top area -->
    <div class="integrationTopArea px-5">
        <div class="border-bottom-medium d-flex flex-row align-items-center py-4">
            <div class="leftArea text-center" v-if="logo">
                <img :src="logo" style="max-width: 80%; max-height: 75px;" alt="Logo">
            </div>

            <div class="rightArea flex-grow-1 w-100">
                <div class="darkest">
                    {{integration.descriptionModal || integration.descriptionSmall}}
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        logo: function () {
            return this.integration && this.integration.logo && this.integration.logo.color ? this.integration.logo.color : false
        }
    },
    props:{
        integration:{
            type: Object,
            required: true
        }
    },
    methods: {
        disableIntegration: function () {
            this.$emit('disableIntegration');
        },
        saveIntegration: function () {
            this.$emit('saveIntegration');
        },
        close: function() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
    .integrationTopArea {
        .leftArea {
            width: 175px;
        }
    }
</style>



// WEBPACK FOOTER //
// topArea.vue?2b28b4da